import { Component } from '@angular/core';
import { RTO_DATA, GENERAL_COMPLIANCE } from '@constants/constants';
import { VendorProfile, vendorProfileMetrics, RtoBarChartConstants } from '@constants/global.enum';
import { GlobalErrorService } from '@services/global-error.service';
import { generateLast12MonthsVendor } from '@utils/utils'

export interface IEmeraldTabData {
  label: string;
}

@Component({
  selector: 'app-quarterly-feedback',
  templateUrl: './quarterly-feedback.component.html',
  styleUrls: ['./quarterly-feedback.component.scss'],
})
export class QuarterlyFeedbackComponent {
  VendorProfile = VendorProfile;
  tabsData: IEmeraldTabData[] = [
    { label: vendorProfileMetrics.compliance },
    { label: vendorProfileMetrics.peopleMetrics },
    { label: vendorProfileMetrics.learningDevelopment },
    { label: vendorProfileMetrics.strategicPartnership },
  ];

  selectedTab: IEmeraldTabData = this.tabsData[0];
  selectedMonth: string = '';
  selectedYear: string = '';
  data: null = null;
  monthOptions: {
    value: string;
    label: string;
    month: string;
    year: string;
    selected?: boolean;
  }[] = [];
  preSelectedValue: string = '';

  constructor(private errorHandler: GlobalErrorService) {}

  onTabChange(tab: any) {
    this.selectedTab = { ...tab, label: tab.label ?? '' };
  }

  tabLabels = {
    Compliance: vendorProfileMetrics.compliance,
    PeopleMetrics: vendorProfileMetrics.peopleMetrics,
    LearningDevelopment: vendorProfileMetrics.learningDevelopment,
    StrategicPartnership: vendorProfileMetrics.strategicPartnership,
  };

  ngOnInit(): void {
    this.monthOptions = generateLast12MonthsVendor();
    const preSelectedOption = this.monthOptions.find(
      (option) => option.selected,
    );
    if (preSelectedOption) {
      this.selectedMonth = preSelectedOption.month;
      this.selectedYear = preSelectedOption.year;
      this.preSelectedValue = preSelectedOption.value;
    }
  }

  onMonthChange(event: any): void {
    let selectedValue: string | undefined;
    if (typeof event === 'string') {
      const monthOption = this.monthOptions.find(
        (option) => option.label === event,
      );
      selectedValue = monthOption ? monthOption.value : undefined;
    } else if (event.value) {
      selectedValue = event.value;
    }

    if (
      !selectedValue ||
      !this.monthOptions.some((option) => option.value === selectedValue)
    ) {
      this.errorHandler.showError(this.VendorProfile.invalidMonthSelected);
      return;
    }

    const selectedOption = this.monthOptions.find(
      (option) => option.value === selectedValue,
    );

    if (selectedOption) {
      this.selectedMonth = selectedOption.month;
      this.selectedYear = selectedOption.year;
      this.preSelectedValue = selectedOption.value;
    }
  }

  rtoData = RTO_DATA;
  generalCompliance = GENERAL_COMPLIANCE;
  rtoConstants = RtoBarChartConstants;
}
